/* eslint-disable arrow-body-style */
import React from 'react';
import PropTypes from 'prop-types';
import { translateElementChildren } from 'utils/translation';

const P = ({ children, translationKey, defaultText, ...rest }) => {
  return (
    <p {...rest}>
      {translateElementChildren(children, translationKey, defaultText)}
    </p>
  );
};

P.propTypes = {
  children: PropTypes.node.isRequired,
  translationKey: PropTypes.string,
  defaultText: PropTypes.string,
};

export default P;
